export class MetroNodeInfo {
    constructor(metroline, station, polyPoint) {
        this.metroline = metroline;
        this.station = station;
        this.polyPoint = polyPoint;
    }
    get Metroline() {
        return this.metroline;
    }
    get PolyPoint() {
        return this.polyPoint;
    }
}
//# sourceMappingURL=MetroNodeInfo.js.map